import api from "./api";

export const useContacto = () => {

  const eliminarContacto = async (id) => {
    try {
      const { data } = await api.delete(`/contacts/eliminar/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar contacto:", error);
      throw error.response?.data?.message || "Error al eliminar contacto";
    }
  };

  const editarContacto = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/contacts/edit/${id}`, params);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar contacto";
    }
  };

  const getContacto = async () => {
    try {
      const { data } = await api.get("/contacts");
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener contactos";
    }
  };

  return {
    eliminarContacto,
    editarContacto,
    getContacto
  };
};